import React, { useState } from "react";
import "./AppointmentSection.css";
import appointmentMobile from "./../../Images/phone-appointment.png";
import WhatsappIcon from "./../../Images/whatsapp.png";
import BenefitsVideo from "./../../Images/benefitsvideo.mp4";
import bookAppointment from "./../../Images/book-appointment.png";
import { useNavigate } from "react-router-dom";
import EnquirePopup from "../EnquirePopup";

const fronturl = process.env.REACT_APP_FRONTEND_URL;

const VideoSection = () => {
  const navigate = useNavigate(null);
  const [showPopup, setShowPopup] = useState(false);

  const handlePopup = () => {
    setShowPopup(true);
  };
  
  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="appointment-sec" style={{backgroundColor:"#fff5af"}}>
      <h2 className="whytext">Why stick with paper when you can <span>go green </span> and digital?</h2>
      <div className="container">
        <div className="row align-center">
          <div className="col-lg-6 col-md-12 second-text2">
            {/* <h2>A business networking platform offering</h2> */}
            {/* <h2>Why stick with paper when you can go green and digital? NFC is the future of smart networking!</h2> */}
            <h2>NFC is the future of smart networking!</h2>
            <div className="benefitspoints">
                <ul>
                    <li><span>NFC Business Card</span> Share your business details with a tap via our sustainable NFC enabled card.</li>
                    <li><span>Easy Appointment Scheduling</span> Let clients book meetings with you effortlessly.</li>
                    <li><span> E-Commerce Platform</span> Sell your products/services by listing your business at our marketplace.</li>
                    <li><span> Multi-Platform App</span> Build & share your own business website on iOS, Android, & Macbook.</li>
                    <li><span>More Clients, More Business</span> Expand your network and get new opportunities.</li>
                </ul>
            </div>
            <a style={{ cursor: "pointer" }} 
            onClick={handlePopup}
             className="green-button">
              {/* <img src={WhatsappIcon} style={{width:"36px", height:"36px"}}/> */}
              Order Your Custom Card
            </a>
          </div>
          <div className="col-lg-6 col-md-12 relative2">
            <div className="benefitsvideo">
            <video width="100%" height="auto" controls autoPlay muted>
                <source src={BenefitsVideo} type="video/mp4" />
            </video>
            </div>
          </div>
        </div>
        {showPopup && (
               <EnquirePopup  open={showPopup} onClose={closePopup} setOpen={setShowPopup}/>
              )}
      </div>
    </div>
  );
};

export default VideoSection;
